import React from 'react';

export const IconNeedList: React.FC<{ className: string; fill?: string }> = ({ className, fill = 'black' }) => (
  <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 2L4 22L20 22L20 7.54023L14.172 2L4 2Z" stroke={fill} strokeWidth="2" />
    <path d="M9 16L15 16" stroke={fill} strokeWidth="2" />
    <path d="M9 13L15 13" stroke={fill} strokeWidth="2" />
  </svg>
);
